<template>
	<footer class="footer">
		<div class="wider-wrapper">
			<div class="footer-row1">
				<div class="footer-col footer-col1" :class="{ active: fCol1 }">
					<div class="footer-title" @click="fCol1 = !fCol1">{{ labels.get('footer_col1_title') }}<span class="toggle-icon"></span></div>
					<BaseCmsNav code="footer_main" v-slot="{items, currentUrl}">
						<ul class="footer-nav" v-if="items?.length">
							<li v-for="item in items" :key="item.id" :class="{'selected': currentUrl == item.url_without_domain}">
								<NuxtLink :to="item.url">
									{{ item.title }}
								</NuxtLink>
							</li>
						</ul>
					</BaseCmsNav>
				</div>
				<div class="footer-col footer-col2" :class="{ active: fCol2 }">
					<div class="footer-title" @click="fCol2 = !fCol2">{{ labels.get('footer_col2_title') }}<span class="toggle-icon"></span></div>
					<BaseCmsNav code="footer_terms" v-slot="{items, currentUrl}">
						<ul class="footer-nav" v-if="items?.length">
							<li v-for="item in items" :key="item.id" :class="{'selected': currentUrl == item.url_without_domain}">
								<NuxtLink :to="item.url">
									{{ item.title }}
								</NuxtLink>
							</li>
							<li><a class="gdpr_configurator_button" id="gdpr_configurator_button" href="javascript:void(0);"><BaseCmsLabel code="footer_gdpr_button" /></a></li>
						</ul>
					</BaseCmsNav>
				</div>
				<div class="footer-col footer-col3 footer-support">
					<div class="footer-title">{{ labels.get('footer_col3_title') }}</div>
					<BaseCmsLabel code="footer_info" class="footer-info" tag="div" />
					<BaseCmsLabel code="social_icons" class="social footer-social" tag="div" />
				</div>
			</div>
			<div class="footer-row2">
				<div class="footer-col footer-col1" :class="{ active: fCol4 }">
					<div class="footer-title" @click="fCol4 = !fCol4">{{ labels.get('footer_catalog_title') }}<span class="toggle-icon"></span></div>
					<BaseCatalogCategoriesWidget :fetch="{hierarhy_by_position: true, response_fields: ['code', 'title', 'url_without_domain']}" v-slot="{items}">
						<ul class="footer-nav footer-nav-categories" v-if="items?.length">
							<li v-for="item in items" :key="item.id">
								<NuxtLink :to="item.url_without_domain">{{ item.title }}</NuxtLink>
							</li>
							<li><NuxtLink :href="getAppUrl('manufacturer')"><BaseCmsLabel code="brands" tag="span" /></NuxtLink></li>
						</ul>
					</BaseCatalogCategoriesWidget>
				</div>
				<div class="footer-col footer-col2" :class="{ active: fCol5 }">
					<div class="footer-title" @click="fCol5 = !fCol5">{{ labels.get('footer_col4_title') }}<span class="toggle-icon"></span></div>
					<BaseCmsLabel code="footer_payment" class="footer-payment" tag="div" />
					<BaseCmsLabel code="footer_payment_cards" class="footer-payment-cards" tag="div" />
				</div>
				<div class="footer-col footer-col3 footer-logos">
					<BaseCmsLabel code="footer_moms_picked" class="moms-picked" tag="div" />
					<BaseCmsLabel code="footer_halmed" class="halmed" tag="div" />
					<div class="footer-trusted-shop">
						<a href="https://safeshop.hr/webshop/ljekarne-prima-farmacia-hr/" class="safe-shop-banner" title="Webshop Trustmark" target="_blank"><img src="https://safeshop.hr/widgets/static/logo/standard/80x80.svg" width="80" height="80" alt="Webshop Trustmark"></a>
					</div>
					<BaseCmsLabel code="footer_legal" class="footer-legal" tag="div" />
					<div class="footer-trusted-shop">
						<a href="https://www.trustprofile.com/hr/webshop/Ljekarne-Prima-Farmacia_4001631" class="trustprofilePopup" title="Oznaka kvalitete webshopa i recenzije kupaca" target="_blank"><img src="https://dashboard.trustprofile.com/banners/4000126/4001631/1633072568.svg" width="64" height="54" alt="Oznaka kvalitete webshopa i recenzije kupaca"></a>
					</div>
				</div>
			</div>
		</div>
		<div class="footer-bottom">
			<div class="wider-wrapper">
				<div class="footer-col footer-col1">
					<BaseCmsCopyright class="copy" tag="div" label="copyright" />
				</div>
				<div class="footer-col footer-col2">
					<div class="signature"><BaseCmsSignature /></div>
				</div>
				<div class="footer-col footer-col3">
					<BaseCmsLabel code="safe_purchase" class="safe-shopping" tag="div" />
				</div>
			</div>
		</div>
	</footer>
</template>

<script setup>
	const {getAppUrl} = useApiRoutes();
	const labels = useLabels();
	let fCol1 = ref(false);
	let fCol2 = ref(false);
	let fCol4 = ref(false);
	let fCol5 = ref(false);

	const {insertAfter, insertBefore, appendTo, onMediaQuery} = useDom();
	onMediaQuery({
		query: '(max-width: 980px)',
		enter: () => {
			appendTo('.footer-support', '.footer-row2');
			appendTo('.footer-row2 .footer-col3', '.footer-row2');
			insertBefore('.footer-row2 .footer-col1', '.footer-row1 .footer-col2');
			insertAfter('.footer-payment-cards', '.footer-social');
			insertAfter('.footer-logos', '.footer-payment-cards');
			appendTo('.safe-shopping', '.footer-logos');
		}
	});
</script>

<style lang="less" scoped>
	.footer{
		background: url(assets/images/bg-main.jpg) top left no-repeat; font-size: 16px; line-height: 1.3; background-size: cover; padding: 90px 0 0; position: relative; content-visibility: auto; contain-intrinsic-size: 715px;
		:deep(a){
			color: var(--textColor); text-decoration: none;
			@media(min-width: @h){
				&:hover{text-decoration: underline; color: var(--primaryColor);}
			}
		}
		&:after{.pseudo(690px,677px); right: 118px; bottom: 0; background: url(assets/images/footer-grafika.png) top left no-repeat; background-size: contain;}
		.wider-wrapper{padding-right: 300px;  z-index: 1; position: relative;}
	}
	.footer-row1{width: auto; display: flex; padding-bottom: 42px;}
	.footer-col{padding-right: 10px;}
	.footer-col1{width: 345px;}
	.footer-col2{width: 395px;}
	.footer-col3{
		width: auto; flex-grow: 1;
		:deep(img){display: block;}
	}

	.footer-title{
		font-size: 22px; line-height: 1.2; padding-bottom: 10px; color: var(--primaryColor); font-weight: normal;
		.toggle-icon{display: none;}
	}
	.footer-nav{
		list-style-type: none; padding-left: 0;
		li{padding: 0 0 6px;}
	}
	.footer-info{
		font-size: 16px; line-height: 23px; font-weight: normal; padding-left: 44px;
		:deep(a){
			font-size: 22px; line-height: 30px; font-weight: bold; position: relative; padding-bottom: 8px; display: inline-block; color: var(--textColor); text-decoration: underline; text-decoration-color: transparent; transition: text-decoration-color .3s, color .3s;
			&:before{.pseudo(auto,auto); left: -42px; .icon-phone; font: 24px/24px var(--fonti); color: var(--primaryColor); top: 3px;}
			@media (min-width: @h){
				&:hover{color: var(--primaryColor); text-decoration-color: var(--primaryColor);}
			}
		}
		:deep(a[href^=mailto]){
			&:before{.icon-mail2; font: 22px/22px var(--fonti); top: 4px; left: 0; left: -44px}
		}
	}

	//ROW2
	.footer-row2{display: flex; padding-bottom: 75px;}
	.footer-row2 .footer-col2{
		:deep(ul){
			list-style: none; padding: 0; margin: 0;
			li{
				padding: 0 0 5px 26px; position: relative;
				&:before{.icon-checkmark-footer; position: absolute; top: 5px; font: 11px/11px var(--fonti); color: var(--primaryColor);left: 0;}
			}
		}
	}
	.footer-row2 .footer-col3{
		display: flex; align-items: center; align-self: baseline; margin-left: 28px;
		:deep(img){display: block; width: auto; height: auto; max-height: 75px;}
		:deep(p){padding: 0;}
		.halmed :deep(img){max-height: 50px;}
		.footer-legal :deep(img){max-height: 55px;}
		:deep(a){display: block; margin-right: 7px;}
	}
	.footer-trusted-shop{margin-left: 10px;}
	.footer-safe-shopping{
		display: flex; align-items: flex-end; font-size: 0;
		:deep(img){margin-right: 6px; margin-top: 8px;}
	}
	.safe-shopping{
		font-size: 16px; line-height: 24px; padding-left: 40px; position: relative;
		&:before{.icon-secure; position: absolute; left: 0; top: -3px;  font: 30px/30px var(--fonti); color: white;}
	}
	.footer-social{display: flex; margin-left: 44px;}
	.footer-nav-categories{
		li{
			a{display: inline-block; text-transform: lowercase;
				&:first-letter{text-transform: uppercase;}
			}
		}
	}
	.footer-payment{
		:deep(p){padding-bottom: 8px;}
	}
	.footer-payment-cards{
		margin-top: 15px;
		:deep(p){display: flex; padding: 0;}
		:deep(img){display: block; width: auto; height: auto; max-height: 23px; margin-right: 3px; max-width: unset;}
	}

	//ROW3
	.footer-bottom{
		background: url(assets/images/purple-bg.jpg) top left no-repeat; background-size: cover; color: white; min-height: 70px; align-items: center; 
		.wider-wrapper{display: flex; align-items: center; min-height: 70px;}
	}
	.copy,.signature{font-size: 14px; line-height: 20px;}
	.signature{
		:deep(a){color: #fff;
			@media(min-width: @h){
				&:hover{color: white;}
			}
			&:nth-child(2){text-decoration: underline;}
		}
	}
	.dev-signature{text-decoration: none;}


	@media (max-width: @l){
		.footer{
			padding: 90px 0 0;
			.wider-wrapper{padding-right: 210px;}
			&:after{width: 580px; height: 560px; right: 0;}
		}
		.footer-col1{width: 305px;}
		.footer-col2{width: 350px;}
		.footer-payment-cards{
			margin-top: 35px;
			:deep(img){max-height: 21px; margin-right: 1px;}
		}
		.footer-row2{padding-bottom: 65px;}
		.footer-info{
			:deep(a){font-size: 20px; line-height: 28px; padding-bottom: 7px;}
		}
	}

	@media (max-width: @t){
		.footer{
			padding: 50px 0 0; font-size: 14px;
			&:after{display: none;}
			.wider-wrapper{padding-right: 0;}
		}
		.footer-col{padding-right: 8px; flex-grow: 1; flex-shrink: 0;}
		.footer-col1{width: 175px;}
		.footer-col2{width: 205px;}
		.footer-col3{width: 230px;}
		.footer-title{font-size: 18px; padding-bottom: 8px;}
		.footer-nav{
			li{padding: 0 0 6px;}
		}
		.footer-info{
			padding-left: 36px; font-size: 14px; line-height: 24px;
			:deep(p){font-size: 14px; line-height: 24px;}
			:deep(a){
				font-size: 18px; line-height: 26px; padding-bottom: 6px;
				&:before{left: -35px; top: 2px; font: 20px/20px var(--fonti);}
			}
			:deep(a[href^=mailto]){
				&:before{font: 18px/18px var(--fonti); top: 4px; left: -36px;}
			}
		}
		.footer-social{margin-left: 36px;}
		.footer-row2{padding-bottom: 50px;
			.footer-col2{
				:deep(p){font-size: 16px; line-height: 24px; padding-bottom: 8px;}
				:deep(ul){
					li{padding: 0 0 5px 22px;}
				}
			}
			.footer-col3{
				margin: 0;
				:deep(a){margin-right: 10px;}
				:deep(img){max-height: 60px;}
				.halmed{
					:deep(img){max-height: 40px;}
				}
			}
		}
		.footer-payment-cards{
			margin-top: 30px;
			:deep(img){max-height: 17px;}
		}
		.safe-shopping{
			font-size: 14px; line-height: 20px; padding-left: 30px;
			&:before{font: 24px/24px var(--fonti); top: -2px;}
		}
		.footer-bottom{
			min-height: 50px;
			.wider-wrapper{min-height: 50px;}
		}
		.copy, .signature{font-size: 12px; line-height: 16px;}
	}

	@media (max-width: @tp){
		.footer{
			padding: 0; font-size: 13px;
			.wider-wrapper{margin: 0;}
		}
		.footer-title{
			font-size: 16px; padding: 15px 40px 15px 15px; position: relative;
			.toggle-icon{display: block; right: 15px; top: 19px; position: absolute;}
		}
		.footer-col{width: 100%;}
		.footer-row1{display: block; padding-bottom: 0;}
		.footer-row2{
			display: block; padding-bottom: 0;
			.footer-col2{
				:deep(ul){
					li{
						&:before{font: 10px/10px var(--fonti); top: 3px;}
					}
				}
			}
		}
		.footer-nav,.footer-payment{visibility: hidden; opacity: 0; max-height: 0;}
		.footer-col{
			width: 100%; padding-right: 0; position: relative; border-bottom: 1px solid var(--borderColor);
			&.active{
				.footer-nav,.footer-payment{visibility: visible; opacity: 1; padding-bottom: 10px; max-height: 2000px;}
				.footer-title{
					padding-bottom: 10px;
					.toggle-icon:before{display: none;}
				}
			}
		}
		.footer-nav,.footer-payment{padding-left: 15px; padding-right: 15px;}
		.footer-info{
			padding-left: 0; text-align: center;
			:deep(a){
				display: inline-block !important;
				&:before{display: none;}
			}
		}
		.footer-support{
			padding-left: 15px; padding-right: 15px; display: block !important; border-bottom: unset !important;
			:deep(a){margin: 0 !important; padding-bottom: 0px;}
			.footer-title{padding: 20px 0 10px 0; text-align: center;}
		}
		.footer-payment-cards{
			margin-top: 18px;
			:deep(img){max-height: 17px !important;}
			:deep(p){align-items: center; justify-content: center; line-height: 0; font-size: 0;}
		}
		.footer-social{
			margin-left: 0; align-items: center; justify-content: center; margin: 12px 0 0;
			:deep(a){
				margin-right: 10px !important; width: 44px; height: 44px; border: unset;
				&:last-child{margin-right: 0 !important;}
				&:before{top: 0; left: 0; width: 44px; height: 44px; font: 18px/18px var(--fonti);}
				&:after{top: 0; left: 0; right: 0; bottom: 0;}
			}
			.in:before{font: 19px/19px var(--fonti) !important;}
			.tt:before{font: 21px/21px var(--fonti) !important;}
		}
		.footer-logos{align-self: unset; justify-content: center; margin-top: 12px !important; margin-bottom: 8px !important; border-bottom: unset !important; flex-wrap: wrap;}
		.footer-bottom{min-height: 75px;
			.wider-wrapper{min-height: 75px; margin: 0 15px; display: block; padding: 20px 15px;}
			.footer-col{border-bottom: unset; }
			.footer-col3{display: none;}
		}
		.copy{padding-bottom: 6px;}
		.footer-trusted-shop{margin-right: 10px;}
		.safe-shopping{
			margin: 15px 0 10px; padding-left: 22px;
			&:before{color: var(--primaryColor); font: 18px/18px var(--fonti); top: 0;}
		}
		.moms-picked{margin-right: 5px !important;
			:deep(img){max-height: 50px !important;}
		}
		.halmed{margin-right: 10px !important;
			:deep(img){max-height: 32px !important;}
		}
		.footer-logos{max-width: 300px; margin: 12px auto 8px!important;}
	}
	@media (max-width: @m){
		.footer{font-size: 14px;}
		.safe-shopping{margin: 15px 0 10px; font-size: 16px;}
		.footer-logos{max-width: 300px; margin: 12px auto 8px!important;}
		.footer-title{font-size: 18px; color: var(--textColor);}
		.footer-support{
			.footer-title{font-weight: bold; color: var(--primaryColor); padding-bottom: 6px;}
		}
		.footer-row2 .footer-col3{
			:deep(img){max-height: 42px;}
			.footer-legal :deep(img){max-height: 44px;}
		}
		.footer-bottom{
			.wider-wrapper{min-height: 75px; margin: 0; display: block; padding: 20px 15px;}
		}
		.copy, .signature{font-size: 14px; line-height: 18px;}	
	}
</style>